import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { ReactNode, useRef } from "react";
import styled from "styled-components";
import Typography from "../../../elements/v2/Typography/Typography";
import ConditionalDisplay from "../../../elements/ConditionalDisplay";

interface Props {
  label: string;
  canRefine?: boolean;
  hasSelectedItems?: boolean;
  children: ReactNode;
}
export default function FilterSection({
  label,
  canRefine = true,
  hasSelectedItems = false,
  children,
}: Props) {
  const defaultExpanded = useRef(hasSelectedItems);

  return (
    <ConditionalDisplay hidden={!hasSelectedItems && !canRefine}>
      <Accordion defaultExpanded={defaultExpanded.current} className="t-searchFilterSection">
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className="t-searchFilterSectionSummary">
          <Title>{label}</Title>
        </AccordionSummary>
        <AccordionDetails className="t-searchFilterSectionDetails">{children}</AccordionDetails>
      </Accordion>
      <Divider variant="middle" component="p" />
    </ConditionalDisplay>
  );
}

export const Title = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  color: #222222;
  text-transform: uppercase;
`;
